// extracted by mini-css-extract-plugin
export default {"Page":"Index-module__Page--bOiPm","Section":"Index-module__Section--e5VkS","Container":"Index-module__Container--GYnML","Component":"Index-module__Component--T9Yes"};